import React from 'react';
import './style.scss';
import getFormatMessage from '../../../locales/get-format-message';
import { IDownloadNews } from '../../../model/api-modules/download-center';
import { MarkdownPreview } from '../../component/message-center/components/markdown/markdown-preview';
import { getCurrentLangText, getFormatDateTime } from '../../../lib';
import accountBg from '../../../assets/img/account-bg-new.png';

interface IProps {
  readonly newsContent: IDownloadNews;
  readonly onKnow: () => void;
}

export const DownloadNewsModal = (props: IProps) => {
  const renderContent = () => {
    const modifyTime =
      getFormatDateTime(props.newsContent.ModifyTime).split(' ') || [];
    return (
      <div className="news-detail-box">
        <div className="news-detail-title">
          {getCurrentLangText(props.newsContent.Title)}
        </div>
        <div className="news-detail-time">
          <span>{`${getFormatMessage('show_update_time')}${
            modifyTime.length !== 0 ? modifyTime[0] : ''
          }`}</span>
        </div>
        <div className="news-detail-content">
          <MarkdownPreview
            value={getCurrentLangText(props.newsContent.Content)}
          ></MarkdownPreview>
        </div>
        <div className="news-detail-btn" onClick={props.onKnow}>
          {getFormatMessage('i_know')}
        </div>
      </div>
    );
  };

  const renderHeaderBg = () => {
    return (
      <div className="news-detail-bg-box">
        <img src={accountBg} className="newsBg" />
      </div>
    );
  };

  return (
    <div
      className="news-detail-modal"
      onClick={(event) => event.stopPropagation()}
    >
      <div className="positionBox" tabIndex={1}>
        <div className="escBox" onClick={props.onKnow}></div>
        <div className="download-news-detail">
          <div className="viewBox">
            {renderHeaderBg()}
            {renderContent()}
          </div>
        </div>
        <div className="mask-style"></div>
      </div>
    </div>
  );
};
